export const VISUAL_TYPE_BY_CATEGORY = Object.freeze({
  foto: 'PHOTOGRAPHER',
  video: 'VIDEOGRAPHER',
});

const VISUAL_SERVICE_TYPES = ['PHOTOGRAPHER', 'VIDEOGRAPHER'];

export const getVisualTypesFromCreativeCategories = (creativeCategories = '') => {
  const categories = Array.isArray(creativeCategories)
    ? creativeCategories
    : String(creativeCategories || '').split(',');

  return categories.reduce((visualTypes, category) => {
    const visualType = VISUAL_TYPE_BY_CATEGORY[String(category || '').trim()];
    if (visualType && !visualTypes.includes(visualType)) {
      visualTypes.push(visualType);
    }
    return visualTypes;
  }, []);
};

export const getSelectableServiceTypesFromCreative = (creative = {}) => {
  if (creative?.creativeType === 'MUSIC') {
    return ['MUSIC_PRODUCER'];
  }

  const visualTypes = Array.isArray(creative?.visualTypes)
    ? creative.visualTypes.filter(Boolean)
    : [];

  const selectableTypes = visualTypes.reduce((serviceTypes, type) => {
    if (VISUAL_SERVICE_TYPES.includes(type) && !serviceTypes.includes(type)) {
      serviceTypes.push(type);
    }
    return serviceTypes;
  }, []);

  return selectableTypes.length > 0 ? selectableTypes : ['PHOTOGRAPHER'];
};

export const getServiceTypeForCreativePackage = (creative = {}, preferredServiceType = null) => {
  const selectableTypes = getSelectableServiceTypesFromCreative(creative);

  if (preferredServiceType && selectableTypes.includes(preferredServiceType)) {
    return preferredServiceType;
  }

  return selectableTypes[0] || 'PHOTOGRAPHER';
};

export const getPrimaryServiceTypeFromCreative = (creative = {}) => {
  return getServiceTypeForCreativePackage(creative);
};
